import dayjs, { Dayjs } from "dayjs";

interface NumberProps {
    value : number
    decimal?: number|"auto"
    delimiter?: string
    separator?: string
    suffix?: string
    prefix?: string
}
export const numberFormat = (props : NumberProps) : string =>
{
    const {value = 0, decimal = 0, delimiter = ",", separator=".", suffix = "", prefix = ""} = props;
    let intPart = decimal === "auto" ? value.toString().split(".").shift() || "" : value.toFixed(decimal).split(".").shift() || "";
    const sign = intPart[0] === "-" ? intPart[0] : ""
    if (sign)
        intPart = intPart.slice(1);

    const length = intPart.length;
    let decimalLength = decimal
    let res = "";

    for (let i = length; i >= 0; i-=3)
        res = (i - 3 > 0 ? delimiter : "") + intPart.slice(Math.max(i -3,0), i) + res;

    if (!decimal)
        return `${sign}${res}`;

    if (decimal === "auto") {
        decimalLength = value.toString().split(".")[1]?.length || 0
    }


    const decimalPart = value.toFixed(decimalLength as number).split(".").pop();


    return `${prefix}${sign}${res}${separator}${decimalPart}${suffix}`
};

interface CurrencyProps {
    value : number
    currency?: string
    format?: string
}
export const currencyFormat = (props : CurrencyProps) : string =>
    {
        const {value = 0, currency = "", format = ""} = props;
        let prefix = "";
        let suffix = currency;
        let delimiter = ",";
        let separator = ".";
        if(format) {
            let match = /^(?<prefix>\$\s?)?x(?<delimiter>[\W\s])xxx(?<separator>[.,])xx(?<suffix>\s?\$)?$/.exec(format)
            if(match) {
                prefix = (match.groups?.prefix || "").replace("$", currency)
                suffix = (match.groups?.suffix || "").replace("$", currency)
                delimiter = match.groups?.delimiter || ","
                separator = match.groups?.separator || "."
            }
        }

        return numberFormat({value: value, decimal: 2, delimiter, separator, suffix, prefix})
        
    };

export const dateFormat = (date: string, options? : {showHours? : boolean, format?:string}) => {
    return dayjs(date).format(options?.format ? options?.format :`DD-MM-YYYY${options?.showHours ? " HH:mm" : ""}`)
}

export const fileSizeFormat = (file_size: number = 0): string => {
    if(typeof file_size === "string") {
        file_size = Number(file_size)
    }
    let result = ""
    if (file_size < 1024)
    {
        result = file_size + "B"
    }
    else if (file_size < 1024*1024)
    {
        result = numberFormat({value: file_size/(1024), decimal: 0}) + "KB"
    }
    else if (file_size < 1024*1024*1024)
    {
        result = numberFormat({value: file_size/(1024*1024), decimal: 0}) + "MB"
    }
    else if (file_size < 1024*1024*1024*1024)
    {
        result = numberFormat({value: file_size/(1024*1024*1024), decimal: 0}) + "GB"
    }
    return result;
};

export const timeFormat = (value: number) : string => {
    let hours = Math.floor(value);
    let minutes = (value - hours) * 60;
    return `${hours.toString().padStart(2, "0")}:${Math.round(minutes).toString().padStart(2, "0")}`
};

export const stringFormat = function(str: string, args: string[]) : string //in arrow function arguments not working!!!
{
    for( let i = 0; i < args.length; i++ ){
        let regexp = new RegExp( '\\{' + (i) + '\\}', 'gim' );
        str = str.replace( regexp, args[i] );
    }
    return str;
};

export enum DatePeriod {
    seconds = "seconds",
    minutes = "minutes",
    hours = "hours",
    days = "days",
    weeks = "weeks",
    months = "months",
    years = "years"
}

export interface DateAddOptions {
    returnDateOnly: boolean
}

export const dateAdd = (date : string|any, value: number, period: DatePeriod, options? : DateAddOptions ) => {
    if (typeof date === "string")
        date = new Date(date)
    const res =  dayjs(date).add(value, period);
    if (options?.returnDateOnly){
        //@ts-ignore
        return res.$d
    }

    //@ts-ignore
    return dayjs(res.$d)
}

export const clearHours = (date : string|any) => {
    if (typeof date === "string")
        date = new Date(date)

    //@ts-ignore
    const result = dayjs(date).startOf('day');
    return result
}

export const timerFormat = (value: number|null, options?:{hideSeconds?:boolean, hours?: string, minutes?: string, seconds?: string }) => {
    if (value === null)
        return "--:--:--"
    const hours = Math.floor (value / (1000 * 60 * 60));
    const minutes = Math.floor (value % (1000 * 60 * 60) / (1000 * 60))
    const seconds = Math.floor (value % (1000 * 60) / (1000))

    return `${hours.toString().padStart(2,"0")}${options?.hours || ":"}${minutes.toString().padStart(2,"0")}${options?.minutes || ""}${!options?.hideSeconds ? ":" + seconds.toString().padStart(2,"0")  +( options?.seconds || "") : ""}`
}

export const countWeekdays = (startDate: string|Date|Dayjs, endDate: string|Date|Dayjs) => {
    let start = dayjs(startDate);
    const end = dayjs(endDate);
    
    let weekdaysCount = 0;
    while (start <= end) {
      const dayOfWeek = start.day();
      
      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        weekdaysCount++;
      }
  
      start = start.add(1, 'day');
    }
  
    return weekdaysCount;
  }

  export const pastTime = (inputDate : Date|string) => {
    let date = inputDate instanceof Date ? inputDate : new Date(inputDate)

    const now = new Date();
    const elapsed = Math.floor((now.getTime() - date.getTime()) / 1000); // Time difference in seconds

    if (elapsed < 60) {
        return { interval: elapsed, type: DatePeriod.seconds };
    } else if (elapsed < 3600) {
        const minutes = Math.floor(elapsed / 60);
        return { interval: minutes, type: DatePeriod.minutes };
    } else if (elapsed < 86400) {
        const hours = Math.floor(elapsed / 3600);
        return { interval: hours, type: DatePeriod.hours };
    } else if (elapsed < 2592000) {
        const days = Math.floor(elapsed / 86400);
        if (days < 7) {
            return { interval: days, type: DatePeriod.days };
        } else {
            const weeks = Math.floor(days / 7);
            return { interval: weeks, type: DatePeriod.weeks };
        }
    } else if (elapsed < 31536000) {
        const months = Math.floor(elapsed / 2592000);
        return { interval: months, type: DatePeriod.months };
    } else {
        const years = Math.floor(elapsed / 31536000);
        return { interval: years, type: DatePeriod.years };
    }
}

